import request from '@/utils/request'

//从环境变量获取auth服务的路径
const VUE_APP_BIZ_PATH = process.env.VUE_APP_BIZ_PATH
//初始化token.从浏览器localstroage中获取
const cachedClientId = localStorage.getItem(process.env.VUE_APP_LOCALSTORAGE_CLIENT_ID)

//初始化state
const state = {
    clientId:cachedClientId
}
  
  //定义getter
  const getters = {
    
  }

  //定义同步的操作，即mutation
const mutations = {
    
}

//定义异步的操作，即action
const actions = {
    /**
     * @description 查询设备信息列表
     * @param {*} userName
     * @param {*} passwd
     * @param {*} clientId
     * @return {Promise}
     */
    // eslint-disable-next-line no-unused-vars
    async getDeviceList({ commit }, params) {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/device/infolist`
        const result = await request.get(url, {params});
        //获取服务返回数据
        return result
    },
    // 查询所有设备类型
    // eslint-disable-next-line no-unused-vars
    async listDeviceType() {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/downList/deviceModel?deviceNameDictValue=`;
         const result = await request.post(url);
        //获取服务返回数据
        return result
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }